import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import './index.scss';

export default function Interior({ style, isInterior, interiorActive, 
  interiors, onInterior, viewActive, views, onViews }) {
  const [ tooltip, setTooltip ] = useState(true);
  useEffect(() => {
    if (tooltip) {
      // setTimeout(() => {
      //   setTooltip(false);
      // }, 5000);
    }
  }, [])
  return (
    <div className="interior-wrapper" style={{...style}}>
      <div 
        className="footer-box footer-inner-wrapper interior-root" 
      >
        {isInterior && 
        <div className="interior-footer footer-sub-nav-container">
          <ul className="footer-sub-nav-list inner-sub-nav-list">
            {interiors.map(interior => 
              <li
                key={interior.uid}
              >
                <div
                  role="button"
                  className="content"
                  onClick={() => {
                    if (interior.uid === interiorActive) return;
                    onInterior(interior);
                  }}
                >
                  <div
                    className={classnames("inner", {
                      active: interiorActive === interior.uid
                    })}
                    style={{
                      backgroundColor : `rgb(${interior.bg.join(',')})`
                    }}
                  >
                  </div>
                  <p className="text">{ interior.name }</p>
                </div>
              </li>
            )}
          </ul>
        </div>}
        {isInterior && 
        <div className="interior-main-wrapper">
          <ul className="footer-main-list interior-list">
            {views.slice(1, views.length).map((view, i) => 
              <li
                key={view.uid}
              >
                <div
                  role="button"
                  className="content"
                  onClick={() => onViews(view)}
                >
                  <div className={classnames("inner-content", {
                      active: viewActive === view.uid
                    })}>
                    <div
                    className={classnames("inner-img-box", {
                      active: viewActive === view.uid
                    })}
                  >
                    <div
                      className="img-box"
                      style={{
                        backgroundImage : `url(${require(`../../images/interior${i + 1}.jpg`)})`
                      }}
                    >
                    </div>
                  </div>
                  <p className="img-text">{ view.name }</p>
                  </div>
                </div>
              </li>
            )}
          </ul>
        </div>}
      </div>
      {tooltip && isInterior &&
      <div className="interior-tooltip">
        <div className="interior-tooltip-content">
          <div className="icon-content">
            <i className="icon-font">&#xe60f;</i>
            <p>双指移动屏幕</p>
          </div>
          <button 
            className="interior-tooltip-btn"
            onClick={() => setTooltip(false)}
          > 知道了 </button>
        </div>
      </div>}
    </div>
  )
}